import { FC, useState } from 'react';

import {
  HotelIcon,
  PlaneIcon,
  TourIcon,
  CarICon,
  //   CruiseIcon,
} from '@assets/icons/shopAndFlyIcons';

import { IconWrapper, TabMenuItem, TextWrapper } from './TabMenu.styled';

export const TAB_MENU_LIST = [
  {
    id: 1,
    key: 'flight',
    text: 'Uçak',
    icon: <PlaneIcon />,
    iconRotate: true,
  },
  {
    id: 2,
    key: 'hotel',
    text: 'Otel',
    icon: <HotelIcon />,
    iconRotate: false,
  },
  {
    id: 3,
    key: 'tour',
    text: 'Tur',
    icon: <TourIcon />,
    iconRotate: false,
  },
  {
    id: 5,
    key: 'carRental',
    text: 'Araç',
    icon: <CarICon />,
    iconRotate: false,
  },
  // {
  //   id: 4,
  // key: 'cruise',
  //   text: 'Gemi',
  //   icon: <CruiseIcon />,
  //   iconRotate: false,
  // },
];

interface ITabMenu {
  onTabChange: (id: number) => void;
  defaultTabId?: number;
}

const TabMenu: FC<ITabMenu> = ({ onTabChange, defaultTabId = 1 }) => {
  const [tabId, setTabId] = useState(defaultTabId);

  const handleTabChange = (id: number) => () => {
    setTabId(id);
    onTabChange(id);
  };

  return (
    <>
      {TAB_MENU_LIST.map((item) => (
        <TabMenuItem
          key={item.id}
          onClick={handleTabChange(item.id)}
          isActive={tabId === item.id ? true : false}
          data-testid={`${item.text.toLowerCase()}-tab-button`}
        >
          <IconWrapper rotate={item.iconRotate}>{item.icon}</IconWrapper>
          <TextWrapper>{item.text}</TextWrapper>
        </TabMenuItem>
      ))}
    </>
  );
};

export default TabMenu;
